import React from 'react';
import Async from 'react-select/async';
import includes from 'lodash/includes';

const DropDownMuti = ({
    title,
    loadOptions,
    onChange,
    onInputChange,
    value,
    placeholder,
}) => (
            <Async
            isMulti
            placeholder={placeholder?placeholder:"- เลือกทั้งหมด "}
            cacheOptions
            defaultOptions
            loadOptions={loadOptions}
            onChange={onChange}
            onInputChange={onInputChange}
            value={value}
            filterOption={(option, inputValue) => includes(option.label, inputValue)}
            />
    );

export default DropDownMuti;
